
import { Card } from "@/components/ui/card";
import { Star } from "lucide-react";
import { format } from "date-fns";

interface Review {
  id: string;
  rating: number;
  comment: string;
  created_at: string;
  reviewer: {
    username: string;
    avatar_url: string | null;
  };
}

interface ProfileReviewsProps {
  reviews: Review[];
}

export const ProfileReviews = ({ reviews }: ProfileReviewsProps) => {
  if (!reviews?.length) {
    return <p className="text-gray-500 text-center py-8">No reviews yet</p>;
  }

  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-semibold mb-4">Reviews</h2>
      {reviews.map((review) => (
        <Card key={review.id} className="p-4">
          <div className="flex items-start gap-4">
            {review.reviewer.avatar_url ? (
              <img
                src={review.reviewer.avatar_url}
                alt={review.reviewer.username}
                className="w-10 h-10 rounded-full object-cover"
              />
            ) : (
              <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
                <span className="text-lg text-gray-500">
                  {review.reviewer.username.charAt(0).toUpperCase()}
                </span>
              </div>
            )}
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <span className="font-medium">{review.reviewer.username}</span>
                <div className="flex items-center">
                  {Array.from({ length: review.rating }).map((_, i) => (
                    <Star key={i} className="w-4 h-4 text-yellow-400 fill-current" />
                  ))}
                </div>
              </div>
              {review.comment && (
                <p className="text-gray-600 mt-1">{review.comment}</p>
              )}
              <p className="text-sm text-gray-400 mt-1">
                {format(new Date(review.created_at), 'MMM d, yyyy')}
              </p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};
